/* eslint-disable no-unused-vars */
import { FontAsset } from "@nolimitcity/slot-launcher/bin/loader/font/FontCache";
import { FontStyle, FontWeight } from "@nolimitcity/slot-launcher/bin/loader/font/FontStatics";

export enum DDDSoundNames {
    WILD_LAND = `wildLand`,
    WILD_ADD_MULTI = `wildAddMulti`,

    FREESPIN_MUSIC = `fs`,
    FS_INTRO_START = `fsIntroStart`,
    FS_INTRO_LOOP = `fsIntro`,
    FS_ON_CONTINUE = `fsStart`,
    FS_OUTRO_BELOW_STAKE = `fsEndBad`,
    FS_OUTRO_WIN = `fsEndGood`,

    SUPER_FREESPIN_MUSIC = `sfs`,
    SFS_INTRO_START = `sfsIntroStart`,
    SFS_INTRO_LOOP = `sfsIntro`,
    SFS_OUTRO_WIN = `sfsEndGood`,

    SCATTER_ACTIVATION = `scatterActivation`,
    SCATTER_ANTICIPATION = `scatterAnticipation`,
    SCATTER_ANTICIPATION_FAIL = `scatterAnticipationFail`,
    SCATTER_ANTICIPATION_WIN = `scatterAnticipationWin`,
    SCATTER_ANTICIPATION_REEL_STOP = `scatterAnticipationReelStop`,
    SCATTER_LANDING_1 = `scatter1Land`,
    SCATTER_LANDING_2 = `scatter2Land`,
    SCATTER_LANDING_3 = `scatter3Land`,
    SCATTER_LANDING_4 = `scatter4Land`,
    SCATTER_TURN_TO_WILDS = `scattersTurnToWilds`,

    CONTINUE_BUTTON = `continueButton`,

    REEL_LAND_1 = `reelLand01`,
    REEL_LAND_2 = `reelLand02`,
    REEL_LAND_3 = `reelLand03`,
    REEL_LAND_4 = `reelLand04`,
    REEL_LAND_5 = `reelLand05`,
    REELS_SPIN = `reelsSpinning`,

    WIN_COUNTUP = `winCountup`,
    WIN_TINY = `winTiny`,
    WIN_SMALL = `winSmall`,
    WIN_MEDIUM = `winMid`,
    WIN_LARGE = `winLarge`,

    BIG_WIN_INTRO = `bigwinIntro`,
    BIG_WIN_LEVEL_CHANGE = `bigWinLevelChange`,
    BIG_WIN_1 = `bigWin1`,
    BIG_WIN_2 = `bigWin2`,
    BIG_WIN_3 = `bigWin3`,
    BIG_WIN_4 = `bigWin4`,
    BIG_WIN_5 = `bigWin5`,
    BIG_WIN_END = `bigWinEnd`,

    MAX_CAP_COUNTUP = `wincapCountup`,
    MAX_CAP_LOOP = `wincapLoop`,

    WIN_SWEEP = `winSweep`,

    MAIN_MUSIC = `background-music-main`,
    MAIN_AMBIENT = `amb-music`,

    AS_WIN = `asWin`,
    AS_WIN_BIG = `asWinBig`,

    WIN_BLINK = `winBlink`,

    XNUDGE_LAND_PARTIAL = `xNudgeLandPartial`,
    XNUDGE_NUDGE_1 = `xNudgeNudgePart1`,
    XNUDGE_NUDGE_2 = `xNudgeNudgePart2`,
    XNUDGE_WIN = `xNudgeWinThing`,
    XNUDGE_HANG = `xNudgeHanging`,
    XNUDGE_FALL = `xNudgeGuyFallsOut`,
    XNUDGE_STICKY = `xNudgeRespinStartBlood`,
    XNUDGE_MULTI_UPDATE = `xNudgeMultiplierNumberUpdate`,
    XNUDGE_RESPIN_MUSIC = `xNudgeRespinLoop`,
    XNUDGE_RESPIN_END = `xNudgeGuyFallsOutRespinEnd`,

    XGOD_LAND_PARTIAL = `xGodLandPartial`,
    XGOD_LAND_FULL = `xGodLandFull`,
}

export const reelLandingSounds: DDDSoundNames[] = [
    DDDSoundNames.REEL_LAND_1,
    DDDSoundNames.REEL_LAND_2,
    DDDSoundNames.REEL_LAND_3,
    DDDSoundNames.REEL_LAND_4,
    DDDSoundNames.REEL_LAND_5,
];

export const scatterLandingSounds: DDDSoundNames[] = [
    DDDSoundNames.SCATTER_LANDING_1,
    DDDSoundNames.SCATTER_LANDING_2,
    DDDSoundNames.SCATTER_LANDING_3,
    DDDSoundNames.SCATTER_LANDING_4,
];

export enum DDDFontsNames {
    DEFAULT = `DDDDefaultFont`,
}

export class DDDWaysTTF {
    public static FAMILY: string = `DDDTTF`;
    public static BASE_URL: string = `/resources/fonts/`;
    public static NORMAL: FontAsset = {
        family: DDDWaysTTF.FAMILY,
        weight: FontWeight.REGULAR,
        style: FontStyle.NORMAL,
        url: DDDWaysTTF.BASE_URL + `DDDWays.ttf`,
    };
}

export class DDDWildTTF {
    public static FAMILY: string = `WildTTF`;
    public static BASE_URL: string = `/resources/fonts/`;
    public static NORMAL: FontAsset = {
        family: DDDWildTTF.FAMILY,
        weight: FontWeight.REGULAR,
        style: FontStyle.NORMAL,
        url: DDDWildTTF.BASE_URL + `DDDWild.ttf`,
    };
}

export enum DDDSpineNames {
    M1 = `spine/DDD/M1.json`,
    M2 = `spine/DDD/M2.json`,
    M3 = `spine/DDD/M3.json`,
    M4 = `spine/DDD/M4.json`,
    M5 = `spine/DDD/M5.json`,
    L1 = `spine/DDD/L1.json`,
    L2 = `spine/DDD/L2.json`,
    L3 = `spine/DDD/L3.json`,
    L4 = `spine/DDD/L4.json`,
    L5 = `spine/DDD/L5.json`,
    SCATTER = `spine/DDD/S.json`,
    WILD = `spine/DDD/W.json`,
    XNUDGE = `spine/DDD/XN.json`,
    XGOD = `spine/DDD/xGod.json`,
    XGOD_ANTICIPATION = `spine/DDD/xGod_anticipation.json`,
    ANTICIPATION = `spine/DDD/anticipation.json`,
    BIG_WIN = `spine/DDD/bigwin.json`,
    MAX_WIN = `spine/DDD/maxwin.json`,
    FS_INTRO = `spine/DDD/introOutro.json`,
    RESPIN_FRAME = `spine/DDD/reel_splat.json`,
}
